import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Benefits() {
  const benefits = ['Más cierre y potencia de agarre', 'Más control sobre la barra o el rival', 'Más resistencia bajo tensión prolongada', 'Transferencia real a todos tus levantamientos', 'Menos fatiga en antebrazos y más rendimiento global'];
  return <section className="py-24 bg-dark-900 relative" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="flex flex-col md:flex-row items-center gap-16 max-w-6xl mx-auto" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-18">
            <h2 className="text-4xl md:text-6xl font-oswald font-bold text-white mb-8 leading-tight" data-id="element-19">
              DESBLOQUEÁ TU <br data-id="element-20" />
              <span className="text-neon-cyan text-shadow-neon" data-id="element-21">
                VERDADERO POTENCIAL
              </span>
            </h2>

            <div className="space-y-6" data-id="element-22">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-23">
                  <CheckCircle2 className="w-8 h-8 text-neon-cyan shrink-0 drop-shadow-[0_0_8px_rgba(0,240,255,0.8)]" data-id="element-24" />
                  <p className="text-xl text-gray-200 font-inter font-medium pt-1" data-id="element-25">
                    {benefit}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2 relative" data-id="element-26">
            {/* Abstract visual representation of strength */}
            <div className="aspect-square rounded-full border border-dark-700 relative flex items-center justify-center" data-id="element-27">
              <div className="absolute inset-4 rounded-full border border-dark-700/50 animate-[spin_20s_linear_infinite]" data-id="element-28"></div>
              <div className="absolute inset-8 rounded-full border border-neon-cyan/20 animate-[spin_15s_linear_infinite_reverse]" data-id="element-29"></div>
              <div className="absolute inset-12 rounded-full border border-neon-cyan/40 animate-[spin_10s_linear_infinite]" data-id="element-30"></div>

              <div className="w-48 h-48 bg-dark-800 rounded-full flex items-center justify-center relative z-10 shadow-neon-cyan border border-neon-cyan" data-id="element-31">
                <div className="text-center" data-id="element-32">
                  <span className="block text-5xl font-oswald font-bold text-white" data-id="element-33">
                    100%
                  </span>
                  <span className="block text-neon-cyan font-oswald tracking-widest mt-2" data-id="element-34">
                    RENDIMIENTO
                  </span>
                </div>
              </div>

              {/* Glowing orbs */}
              <div className="absolute top-0 left-1/2 w-4 h-4 bg-neon-cyan rounded-full shadow-neon-cyan blur-[2px]" data-id="element-35"></div>
              <div className="absolute bottom-1/4 right-0 w-3 h-3 bg-neon-cyan rounded-full shadow-neon-cyan blur-[2px]" data-id="element-36"></div>
              <div className="absolute top-1/3 left-0 w-2 h-2 bg-neon-cyan rounded-full shadow-neon-cyan blur-[2px]" data-id="element-37"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}